import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
// import Container from '@mui/material/Container'
import ImageWithSkeleton from '../../components/ImageWithSkeleton.js'
import Box from '@mui/material/Box'
import { fadeInAnimation } from '../../utils/cssFunctions.js'

export default function RaceHeader ({ raceData }) {
  const { t } = useTranslation('race')
  return (
    <>
      {/* Keep this in place as is */}
      {/* <Grid size={{ xs: 12, md: 3, lg: 3 }}> */}
      <Box
        sx={{
          overflow: 'hidden',
          boxShadow: 3,
          width: '100%',
          // maxWidth: 640,
          // mx: 'auto',
          position: 'relative',
          ...fadeInAnimation,
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            boxShadow: (theme) => `inset 0 0 0 1px ${theme.palette.divider}`
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '120px',
            background: 'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)',
            zIndex: 3
          }
        }}
      >
        <ImageWithSkeleton src={raceData.image || `https://d1hi0tbu2kom2c.cloudfront.net/img/races/i/${raceData.slug}.jpg`} ratio={2} square imageSx={{ aspectRatio: '2 / 1', objectFit: 'cover', objectPosition: 'center' }} />
      </Box>
      {/* </Grid> */}
      {/* The following grid has to move up, around 240px to come at the bottom of the grid above. */}
      <Box
        sx={{
          px: 2,
          maxWidth: 960,
          position: 'absolute',
          bottom: 0,
          zIndex: 1,
          // pb: 4,
          ...fadeInAnimation
        }}
      >
        <Typography
          component='h1'
          sx={{
            textAlign: 'left !important',
            color: `${raceData.color || 'white'} !important`,
            fontSize: { xs: '1.5rem', md: '2rem' },
            fontWeight: 700,
            ...fadeInAnimation
          }}
        >
          {raceData.title}
        </Typography>

        <Typography
          component='h2'
          sx={{
            textAlign: 'left !important',
            color: `${raceData.color || 'white'} !important`,
            fontSize: { xs: '1.1rem', sm: '1.3rem' },
            ...fadeInAnimation
          }}
        >
          {raceData?.subtitle}
        </Typography>

        <Typography
          variant='caption'
          sx={{ display: 'block', fontWeight: 'bold', ...fadeInAnimation }}
          color={raceData.status === 'open' ? 'success.main' : 'warning.main'}
        >
          {raceData.status === 'open' ? t('status.open') : t('status.closed')}
        </Typography>
      </Box>
    </>
  )
}
